module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Box#3-f7f097cf8f888f75cfe2e9847009dd19.svg";